(function () {
  function getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'CartDrawer-CartItems',
        section: 'cart-drawer',
        selector: '#CartDrawer-CartItems'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  function getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : '';
  }

  async function addAccessory(variantId) {
    const sections = getSectionsToRender().map(section => section.section);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.description || data.message || 'Accessoire toevoegen mislukt');
    }

    return data;
  }

  function renderCartSections(parsedState) {
    if (!parsedState.sections) return;

    getSectionsToRender().forEach(function (section) {
      const container = document.getElementById(section.id);
      if (!container) return;

      const html = parsedState.sections[section.section];
      if (!html) return;

      const newHtml = getSectionInnerHTML(html, section.selector);
      if (newHtml) {
        container.innerHTML = newHtml;
      }
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    const cartIcon =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[href="/cart"]');

    if (cartIcon) {
      cartIcon.click();
    }
  }

  async function syncAccessoryCheckboxes() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    document.querySelectorAll('.accessoires__checkbox').forEach(function (checkbox) {
      const stillInCart = cart.items.some(function (item) {
        return String(item.variant_id) === String(checkbox.value);
      });

      checkbox.checked = stillInCart;
    });
  }

  document.addEventListener('change', async function (event) {
    const checkbox = event.target;

    if (!checkbox.classList.contains('accessoires__checkbox')) return;

    checkbox.disabled = true;

    try {
      if (checkbox.checked) {
        const parsedState = await addAccessory(checkbox.value);
        renderCartSections(parsedState);
        openCartDrawer();
      }

      await syncAccessoryCheckboxes();

    } catch (error) {
      console.error(error);
      checkbox.checked = false;
      alert(error.message || 'Accessoire kon niet worden toegevoegd.');
    }

    checkbox.disabled = false;
  });

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('cart-remove-button');

    if (!removeButton) return;

    setTimeout(function () {
      syncAccessoryCheckboxes();
    }, 800);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAccessoryCheckboxes();
  });
})();